const InfoAlert = () => {
    return (
        <div className="info-alert">
           <span>LET US BUILD YOUR PROFILE</span><i className="fa fa-circle mx-2 color-danger"></i><span>UNLEASH THE POWER OF YOUR RESEARCH</span>
        </div>
    )
}

export default InfoAlert